<ng-template #confModal let-modal>
  <div class="dialog">
    <div class="modal-header">
      <h4 class="modal-title text-center obfuscated-playback">{{ title }}</h4>
    </div>
    <div class="modal-body obfuscated-playback">
      <div>{{ label }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-success" (click)="confirm('false')">No</button>
      <button class="btn btn-warning" (click)="confirm('true')">Yes</button>
    </div>
  </div>
</ng-template>
